import {withRedirect} from '@dynamynd/core';
import {HomeScreen, shouldRedirectAuth, WithPopupLayout} from '@dynamynd/dynamynd';
import {RoutesKeysEnum} from '@dynamynd/routes';
import React from 'react';
import {compose} from 'redux';
import {withAnalyticsTrackerWeb} from '../core/withAnalyticsTrackerWeb';

const EnhancedHomeScreen = compose(
    withAnalyticsTrackerWeb,
    withRedirect<any>(shouldRedirectAuth, RoutesKeysEnum.dashboard)
)(HomeScreen) as any;

/**
 * Wrapper for the ContactUsScreen to add analytics tracking, PopupLayout, and navigation props passthrough
 * @param props
 * @returns
 */
export function HomeNavigator(props: any) {
    return (
        <WithPopupLayout>
            <EnhancedHomeScreen {...props} />
        </WithPopupLayout>
    );
}
